import React from 'react';
import { CloseButton, Popover, PopoverButton as HeadlessPopoverButton, PopoverPanel } from '@headlessui/react';
import PropTypes from 'prop-types';

import Icon, { IconV2 } from './Icon';

const PopoverButton = ({ iconBefore, iconAfter, label, className, dropdownClassName, iconOnly = false, iconV2 = false, closable, children }) => {
  return (
    <Popover className={'dealer-popover-container' + (className ? ' ' + className : '')}>
      <HeadlessPopoverButton className={iconOnly ? `dealers-button secondary w-icon dealer-popover-button-icon`: 'dealer-popover-button'} aria-label={iconOnly ? (label || '') : undefined}>
        {iconBefore && (<span className="dealer-popover-button__icon-before">{iconV2 ? <IconV2 icon={iconBefore} /> : <Icon icon={iconBefore} alt={''} />}</span>)}
        {label && !iconOnly && (<span className="dealer-popover-button__label">{label}</span>)}
        {iconAfter && (<span className="dealer-popover-button__icon-after">{iconV2 ? <IconV2 icon={iconAfter} /> : <Icon icon={iconAfter} alt={''} />}</span>)}
      </HeadlessPopoverButton>
      <PopoverPanel anchor="bottom" className={'dealer-popover-dropdown' + (dropdownClassName ? ' ' + dropdownClassName : '')} transition>
        {(props) => (
          <div className="dealer-popover-dropdown__content">
            {closable && (
              <CloseButton className="dealer-popover-dropdown__close">
                &#215;
              </CloseButton>
            )}
            {children(props)}
          </div>
        )}
      </PopoverPanel>
    </Popover>
  )
}

PopoverButton.propTypes = {
  className: PropTypes.string,
  dropdownClassName: PropTypes.string,
  iconBefore: PropTypes.string,
  iconAfter: PropTypes.string,
  iconOnly: PropTypes.bool,
  iconV2: PropTypes.bool,
  closable: PropTypes.bool,
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  children: PropTypes.func,
};

export default PopoverButton;
